export default "__VITE_ASSET__5wLoNfLP__"